import { TopBar } from '../../top-bar/TopBar';
import { PublicOptions } from '../../../data/publicOptions';
import { Footer } from '../../footer/Footer';
import { Register } from './Register';

export const RegisterWrapper = () => {
  return (
    <>
      <TopBar options={PublicOptions} />
      <div className="content">
        <Register />
      </div>
      <Footer />
    </>
  );
};
